import { Component, inject, OnInit } from "@angular/core";
import { Auth } from "../../../services/auth";
import { Router } from "@angular/router";
import { Master } from "../../../services/master";
import { QuestionState } from "../../../services/question-state";
import { LogoutDialog } from "../logout-dialog/logout-dialog";
import { MatDialog } from "@angular/material/dialog";
import { NavStateService } from "../../../services/nav-state.service";
import { NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-side-navigation",
  standalone: false,
  templateUrl: "./side-navigation.html",
  styleUrl: "./side-navigation.less",
})
export class SideNavigation implements OnInit {
  private authService = inject(Auth);
  private router = inject(Router);
  private _dialog = inject(MatDialog);
  private navStateService = inject(NavStateService);
  private masterService = inject(Master);
  private questionState = inject(QuestionState);
  tradeHistory: any[] = [];
  rowNum: any = 0;
  size: any = 10;
  chatHistory: {
    question: '',
    answer: ''

  }[] = [];
  isOpen = true;
  imgData: any;
  user: any;
  sellerNavItems = [
    // {
    //   label:'Dashboard',
    //   route:'/seller-dashboard',
    //   iconClass:'dashboard',
    //   children:[]
    // },
    {
      label: 'Trade GPT',
      route: '/trade-gpt',
      iconClass: 'tradeGPT',
      iconClassActive: 'trade-gpt-white',
      children: []
    },
    {
      label: 'My Catalog',
      route: '/seller-catalog',
      iconClass: 'catalog',
      iconClassActive: 'browse-white',
      children: [
        {
          label: 'Update Catalog',
          route: '/update-seller-catalog',
          iconClass: 'bi bi-pencil-square',
        }
      ]
    },
    {
      label: 'Orders',
      route: '/my-shipments',
      iconClass: 'orders',
      iconClassActive: 'orders-white',
      children: [
        {
          label: 'Shipment Details',
          route: '/my-shipments/shipment-details',
          iconClass: 'bi bi-pencil-square',
        }
      ]
    }

  ];

  buyerNavItems = [
    // {
    //   label:'Dashboard',
    //   route:'/buyer-dashboard',
    //   iconClass:'dashboard',
    //   children:[]
    // },
    {
      label: 'Trade GPT',
      route: '/trade-gpt',
      iconClass: 'tradeGPT',
      iconClassActive: 'trade-gpt-white',
      children: []
    },
    {
      label: 'Catalog',
      route: '/catalog',
      iconClass: 'catalog',
      iconClassActive: 'browse-white',
      children: [
        {
          label: 'Add a quote',
          route: '/create-order',
          iconClass: 'bi bi-pencil-square',
        }
      ]
    },
    {
      label: 'My Quotes',
      route: '/quote',
      iconClass: 'quotes',
      iconClassActive: 'quotes-white',
      children: [
        {
          label: 'Update Quote',
          route: '/update-quote',
          iconClass: 'bi bi-pencil-square',
        }
      ]

    },
    {
      label: 'My Orders',
      route: '/buyer-orders',
      iconClass: 'orders',
      iconClassActive: 'orders-white',
      children: [
        {
          label: 'View order details',
          route: '/buyer-orders/shipment-details',
          iconClass: 'bi bi-pencil-square',
        }
      ]
    },
    {
      label: 'My Requirements',
      route: '/requirement-list',
      iconClass: 'requirements',
      iconClassActive: 'requirements-white',
      children: []
    }

  ]

  adminNavItems = [
    {
      label: 'Catalog',
      route: '/master-catalog',
      iconClass: 'master-catalog',
      iconClassActive: 'master-catalog-white',
      children: [
        {
          label: 'Master Catalog',
          route: '/master-catalog',
          iconClass: 'bi bi-pencil-square',

          children: [

            {
              label: 'Update Article',
              route: '/update-master-catalog',
              iconClass: 'bi bi-gear',
              children: []
            }
          ]

        },
        {
          label: 'Seller Catalog',
          route: '/catalog',
          iconClass: 'bi bi-pencil-square',
          children: []
        }
      ]
    },

    {
      label: 'Manage Orders',
      route: '/manage-orders',
      iconClass: 'orders',
      iconClassActive: 'orders-white',
      children: [
        {
          label: 'Update Order',
          route: '/view-update-order-details',
          iconClass: 'bi bi-pencil-square',
          children: []
        }
      ]
    },
    {
      label: 'Requirements',
      route: '/requirement-list',
      iconClass: 'requirements',
      iconClassActive: 'requirements-white',
      children: []
    },
    {
      label: 'Admin Dashboard',
      route: '/admin-dashboard',
      iconClass: 'admin-dashboard',
      iconClassActive: 'admin-dashboard-white',
      children: []
    },
    {
      label: 'New Article',
      route: '/add-article',
      iconClass: 'new-article',
      iconClassActive: 'new-article-white',
      children: []
    }, {

      label: 'Manage Roles',
      route: 'manage-role-privileges',
      iconClass: 'manage-roles',
      iconClassActive: 'manage-roles-white',
      children: []

    },
    {
      label: 'Manage Users',
      route: '/manage-users',
      iconClass: 'manage-users',
      iconClassActive: 'manage-users-white',
      children: [
        {
          label: 'Update User Profile',
          route: '/update-user-profile',
          iconClass: 'bi bi-pencil-square',
          children: []
        }
      ],
    }
  ];

  salesTeamNavItems = [
    {
      label: 'CRM Requests Online',
      route: '/crm/online-list',
      iconClass: 'canon-list',
      children: []
    },
    {
      label: 'CRM Requests Offline',
      route: '/crm/offline-list',
      iconClass: 'canon-list',
      children: []
    }
  ];

  // Navigation groups for dynamic bottom bar switching
  navGroups: { [role: string]: { primary: any[], secondary: any[] } } = {
    'SALES_TEAM': {
      primary: [
        { label: 'CRM Requests Online', route: '/crm/online-list', icon: '/side-panel/canon-list-blue.svg' },
        { label: 'CRM Requests Offline', route: '/crm/offline-list', icon: '/side-panel/canon-list-blue.svg' }
      ],
      secondary: [
        { label: 'Callback Request', route: '/admin/callback-request', icon: '/side-panel/MyRequirements-blue.svg' },
        { label: 'Profile', route: '/profile', icon: '/side-panel/Profile.svg' },
        { label: 'Logout', icon: '/icons/logout.svg', click: () => this.logout() }
      ]
    },
    'SELLER': {
      primary: [
        { label: 'Trade GPT', route: '/seller/trade-gpt', icon: '/side-panel/Tradegpt-blue.svg' },
        { label: 'Catalog', route: '/seller/seller-catalog', icon: '/side-panel/Catalog-blue.svg' },
        { label: 'Orders', route: '/seller/my-shipments', icon: '/side-panel/MyOrders-blue.svg' }
      ],
      secondary: [
        { label: 'Verify Your Buyers', route: '/seller/verification-summary', icon: '/side-panel/Verify-user.svg' },
        // { label: 'Verification List', route: '/seller/verification-list', icon: '/side-panel/MyRequirements-blue.svg' },
        // { label: 'My Verifications', route: '/seller/verification-history', icon: '/side-panel/verification-history.svg' },
        { label: 'Profile', route: '/profile', icon: '/side-panel/Profile.svg' },
        { label: 'Logout', icon: '/icons/logout.svg', click: () => this.logout() }
      ]
    },
    'BUYER': {
      primary: [
        { label: 'Trade GPT', route: '/buyer/trade-gpt', icon: '/side-panel/Tradegpt-blue.svg' },
        { label: 'Catalog', route: '/buyer/catalog', icon: '/side-panel/Catalog-blue.svg' },
        { label: 'My Quotes', route: '/buyer/quote', icon: '/side-panel/MyQuotes-blue.svg' }
      ],
      secondary: [
        { label: 'My Orders', route: '/buyer/buyer-orders', icon: '/side-panel/MyOrders-blue.svg' },
        { label: 'My Requirements', route: '/buyer/requirement-list', icon: '/side-panel/MyRequirements-blue.svg' },
        // { label: 'Verify Your Sellers', route: '/buyer/verification-summary', icon: '/side-panel/Verify-user.svg' },
        // { label: 'Verification List', route: '/buyer/verification-list', icon: '/side-panel/verification-list.svg' },
        // { label: 'My Verifications', route: '/buyer/verification-history', icon: '/side-panel/verification-history.svg' },
        { label: 'Profile', route: '/profile', icon: '/side-panel/Profile.svg' },
        { label: 'Logout', icon: '/icons/logout.svg', click: () => this.logout() }
      ]
    },
    'ADMIN': {
      primary: [
        { label: 'Trade GPT', route: '/admin/trade-gpt', icon: '/side-panel/Tradegpt-blue.svg' },
        { label: 'Browse', route: '/admin/master-catalog', icon: '/side-panel/Catalog-blue.svg' },
        { label: 'Orders', route: '/admin/manage-orders', icon: '/side-panel/MyOrders-blue.svg' }
      ],
      secondary: [
        { label: 'Callback Requests', route: '/admin/callback-request', icon: '/side-panel/MyRequirements-blue.svg' },
        { label: 'Admin Dashboard', route: '/admin/admin-dashboard', icon: '/side-panel/MyRequirements-blue.svg' },
        { label: 'Requirements', route: '/admin/requirement-list', icon: '/side-panel/MyRequirements-blue.svg' },
        { label: 'Import Price Calculator', route: '/admin/import-price-calculator', icon: 'public/side-panel/import-price-calculator-icon.svg' },
        { label: 'New Article', route: '/admin/add-article', icon: '/icons/new-article.svg' },
        { label: 'Contracts', route: '/admin/manage-intents', icon: '/icons/available-contract.svg' },
        { label: 'Manage Users', route: '/admin/manage-users', icon: '/icons/manage-users.svg' },
        { label: 'Verify User', route: '/admin/verification-summary', icon: '/side-panel/Verify-user.svg' },
        // { label: 'Verification List', route: '/admin/verification-list', icon: '/side-panel/verification-list.svg' },
        // { label: 'Verification History', route: '/admin/verification-history', icon: '/side-panel/verification-history.svg' },
        // { label: 'Audit List', route: '/admin/audit-list', icon: '/side-panel/audit-list.svg' },
        // { label: 'Canon List', route: '/admin/canon-list', icon: '/side-panel/canon-list.svg' },
        { label: 'Profile', route: '/profile', icon: '/side-panel/Profile.svg' },
        { label: 'Logout', icon: '/icons/logout.svg', click: () => this.logout() }
      ]
    },
    'INVESTOR': {
      primary: [
        { label: 'Dashboard', route: '/investor/market-intelligence', icon: '/side-panel/Tradegpt-blue.svg' },
        { label: 'Portfolio', route: '/investor/portfolio', icon: '/side-panel/Portfolio-blue.svg' },
        { label: 'Available Contract', route: '/investor/proposal-list', icon: '/icons/available-contract.svg' }
      ],
      secondary: [
        { label: 'Invested Contract', route: '/investor/intents', icon: '/icons/invested-contract.svg' },
        { label: 'Wallet', route: '/investor/wallet', icon: '/icons/wallet.svg' },
        { label: 'Profile', route: '/profile', icon: '/side-panel/Profile.svg' },
        { label: 'Logout', icon: '/icons/logout.svg', click: () => this.logout() }
      ]
    }
  };

  getCurrentRole(): string {
    if (this.isPrivileged(['IS_SELLER_ADMIN', 'IS_SELLER'])) return 'SELLER';
    if (this.isPrivileged(['IS_BUYER'])) return 'BUYER';
    if (this.isRole(['SALES_TEAM'])) return 'SALES_TEAM';
    if (this.isPrivileged(['ADMIN', 'SUPERADMIN'])) return 'ADMIN';
    if (this.isPrivileged(['INVESTOR_ADMIN', 'IS_INVESTOR', 'IS_INVESTOR_ADMIN'])) return 'INVESTOR';
    return '';
  }

  isSecondaryActive(): boolean {
    const role = this.getCurrentRole();
    if (!role || !this.navGroups[role]) return false;

    const currentUrl = this.router.url;
    // Special case for profile since it's common
    if (currentUrl.includes('/profile')) return true;

    return this.navGroups[role].secondary.some(item => 
      item.route && (currentUrl.startsWith(item.route) || this.router.isActive(item.route, { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }))
    );
  }

// 1. Add this property at the top of your component class to persist the window state
private currentSecondaryStartIndex = 0;

getVisibleNavItems(): any[] {
  const role = this.getCurrentRole();
  if (!role || !this.navGroups[role]) return [];

  if (this.isSecondaryActive()) {
    const secondaryList = this.navGroups[role].secondary || [];
    
    // Find the index of the newly active item
    const activeIndex = secondaryList.findIndex(item => this.isCurrentRouteActive(item.route));

    if (activeIndex !== -1) {
      // Calculate the boundaries of the window currently shown on screen
      const currentEndIndex = this.currentSecondaryStartIndex + 3;

      // CHECK: Is the selected item ALREADY within the visible 3-item window?
      const isAlreadyVisible = activeIndex >= this.currentSecondaryStartIndex && activeIndex < currentEndIndex;

      // Only shift the window if the item is outside the current view
      if (!isAlreadyVisible) {
        // If it's a new item outside the view, make it the first item
        this.currentSecondaryStartIndex = activeIndex;

        // Safety check: Don't let the window overshoot the end of the array
        if (this.currentSecondaryStartIndex + 3 > secondaryList.length) {
          this.currentSecondaryStartIndex = Math.max(0, secondaryList.length - 3);
        }
      }
    } else {
      // Fallback if no route matches
      this.currentSecondaryStartIndex = 0;
    }

    // Return the stable slice based on our persistent window index
    return secondaryList.slice(this.currentSecondaryStartIndex, this.currentSecondaryStartIndex + 3);
  }

  // Reset window index when primary is active, and return primary items
  this.currentSecondaryStartIndex = 0;
  return this.navGroups[role].primary.slice(0, 3);
}

private isCurrentRouteActive(route: string): boolean {
  return this.router.url.includes(route);
}
  getHiddenNavItems(): any[] {
    const role = this.getCurrentRole();
    if (!role || !this.navGroups[role]) return [];

    const visibleItems = this.getVisibleNavItems();
    const allItems = [...this.navGroups[role].primary, ...this.navGroups[role].secondary];

    // Hidden items are all items that are NOT currently in the visible list
    return allItems.filter(item => !visibleItems.some(v => (v.route || v.label) === (item.route || item.label)));
  }

  isAnyRouteActive(items: any[]): boolean {
    const currentUrl = this.router.url;
    return items.some(item => 
      item.route && (currentUrl.startsWith(item.route) || this.router.isActive(item.route, { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }))
    );
  }

  getItemIcon(item: any): string {
    const isActive = item.route && (this.router.url.startsWith(item.route) || 
                     this.router.isActive(item.route, { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }));
    
    if (isActive) return item.icon;

    // Handle Profile separately if it doesn't follow the -blue/-gray pattern in the map
    if (item.label === 'Profile') return '/side-panel/Profile-gray.svg';

    if (item.icon && item.icon.includes('canon-list')) return '/side-panel/canon-list.svg';

    return item.icon.replace('-blue.svg', '-gray.svg');
  }
  constructor() {
    this.authService.user.subscribe((x: any) => (this.user = x));
    // this.authService.imgData.subscribe((img: any) => (this.imgData = img));
    // this.getTradeGPTHistory(this.rowNum,this.size);
  }
  ngOnInit(): void {
    // this.questionState.updatedChatHistory$.subscribe((h:any)=>console.log(h));
    // console.log(this.chatHistory);
    if(this.user){
        this.questionState.updatedChatHistory$.subscribe((h: any) => {
      console.log('Sidebar got:', h);
      this.chatHistory = h;
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateHeaderTitle(event.urlAfterRedirects);
    });
    // Call once initially
    this.updateHeaderTitle(this.router.url);
    }
  
  }

  updateHeaderTitle(url: string) {
    let navItems: any[] = [];
    if (this.isPrivileged(['IS_SELLER_ADMIN', 'IS_SELLER'])) {
      navItems = this.sellerNavItems;
    } else if (this.isPrivileged(['IS_BUYER'])) {
      navItems = this.buyerNavItems;
    } else if (this.isRole(['SALES_TEAM'])) {
      navItems = this.salesTeamNavItems;
    } else if (this.isPrivileged(['ADMIN', 'SUPERADMIN'])) {
      navItems = this.adminNavItems;
    }

    let foundTitle = 'Dashboard';

    if (url.includes('/profile')) {
      foundTitle = 'Profile';
    } else {
      for (const item of navItems) {
        if (url.includes(item.route)) {
          foundTitle = item.label;
          break;
        }
        if (item.children) {
          let childMatched = false;
          for (const child of item.children) {
            if (url.includes(child.route)) {
              foundTitle = item.label;
              childMatched = true;
              break;
            }
          }
          if (childMatched) break;
        }
      }
    }

    this.navStateService.setCurrentTitle(foundTitle);
  }

  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }

  logout() {
    this.showLogoutDialog();
    // this.authService.logout();
  }

  showLogoutDialog() {
    const dialog = this._dialog.open(LogoutDialog, {
      data: {
        title: 'Are you sure you want to logout?',
        subtitle: 'You will need to enter your credentials to access your account again .'
      },
      
      width: '500px',
      panelClass: 'custom-dialog-container'
    })
    dialog.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result == 'logout') {
        this.authService.logout();
      }
    })
  }
  getTradeGPTHistory(rowNum: any, size: any) {
    this.masterService.getTradeGPTHistory(rowNum, size).
      subscribe({
        next: (data: any) => {
          this.tradeHistory = data.rows;
          console.log(this.tradeHistory);
          this.generateHistoryRecord(this.tradeHistory);
          console.log(this.tradeHistory);
        }
      })
  }

  isPrivileged(privilege: string[]) {
    const privileges: any[] = this.user.privileges;
    var check = privileges.some((x: any) => privilege.includes(x));
    return check;
  }
   isRole(privilege: string[]) {
    const privileges: any[] = this.user.roles;
    var check = privileges.some((x: any) => privilege.includes(x));
    return check;
  }

  isChildRouteActive(children: any[]): boolean {
    if (!children || children.length === 0) {
      return false;
    }
    const currentUrl = this.router.url;
    return children.some(child => currentUrl.startsWith(child.route));
  }


  generateHistoryRecord(tradeHistory: any) {
    console.log(tradeHistory.length);
    for (let i = 0; i < tradeHistory.length; i += 2) {
      this.chatHistory.push({
        answer: tradeHistory[i].chat || null,
        question: tradeHistory[i + 1].chat || null
      })
    }
    console.log(this.chatHistory);
    this.questionState.setChatHistory(this.chatHistory);
  }

  openTradeGPT(chat: any) {
    this.router.navigate(['/trade-gpt'])
    this.questionState.setQuestion(chat);
  }

  openNewTrade() {
    this.questionState.setQuestion(null);
  }

  addNewChat() {
    this.router.navigate(['/trade-gpt'])
    this.questionState.setQuestion('');
  }

}
